import { render, staticRenderFns } from "./WelcomeMessage.vue?vue&type=template&id=17d803a2&scoped=true&lang=pug&"
var script = {}
import style0 from "./WelcomeMessage.vue?vue&type=style&index=0&id=17d803a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d803a2",
  null
  
)

export default component.exports